const serializeArray = (form) => {
  let serialized = [];

  for ( let i = 0; i < form.elements.length; i++ ) {
    let field = form.elements[i];

    if ( !field.name || field.type === 'file' || field.type === 'reset' || field.type === 'submit' || field.type === 'button' || field.getAttribute('data-ignore') === "true" ) continue;

    if ( (field.type !== 'checkbox' && field.type !== 'radio') || field.checked ) {
      serialized.push({
        name: field.name,
        value: field.value
      })
    }
  }

  return serialized;
}

export { serializeArray as serialize }